import "@/style/indexList.scss"
import "@/style/inConstruction.scss"
import "@/utils/nav"
import "@/utils/tab.js"
import "@/utils/website.js"

function get(par) {
    const local_url = decodeURI(document.location.href)
    const getstr = local_url.substr(local_url.indexOf('?') + 1)
    const get = getstr.split('&')
    for (var i in get) {
        if (get[i].indexOf(par + '=') >= 0) {
            return get[i].replace(par + '=', '')
        }
    }
    return false
}
const id = get('id')
const subId = get('subId')
const idx = get('idx')
const name = get('name')
const bg = get('bg')
const nav = $("#member-nav").text()
$('.member-us').append(name)

let bgList = `<img class="bg-img" src= ${bg} />`
$('#bg-box').html(bgList)

$.get(`/api/admin/official/exc/informationPageList/${id}?current=1&size=12`, function (data) {
    if (data.data.size >= data.data.total) {
        $(".more").hide()
    }
    const memberList = data.data.records
    var contentList = ''
    $.each(memberList, function (i, item) {
        if (memberList[i].subtitle === null) {
            memberList[i].subtitle = ""
        }
        if (memberList[i].coverUrl === "") {
            memberList[i].coverUrl = "/static/images/bg.png"
        }
        if (memberList[i].linkType === 0 || memberList[i].linkType === null) {
            contentList +=
                "<a class= " + 'content-list ' + "href=" + 'memberDetail.html?idx=' + idx + '&id=' + memberList[i].id + '&nav=' + encodeURI(nav) + ">" +
                "<img class= " + 'content-img ' + "src=" + memberList[i].coverUrl + ">" + "</img>" +
                '<div class="detail-title">' + memberList[i].title + '</div>' +
                '<div class="content-detail">' +
                '<div class="detail-content">' + memberList[i].subtitle + '</div>' +
                '<div class="detail-time ">' + memberList[i].publicTime + '</div>' +
                '</div>' +
                "</a>"
            $(".content-list-box").html(contentList)
        } else {
            contentList +=
                "<a class= " + 'content-list ' + "href=" + memberList[i].linkUrl + ' target=_blank' + ">" +
                "<img class= " + 'content-img ' + "src=" + memberList[i].coverUrl + ">" + "</img>" +
                '<div class="detail-title">' + memberList[i].title + '</div>' +
                '<div class="content-detail">' +
                '<div class="detail-content">' + memberList[i].subtitle + '</div>' +
                '<div class="detail-time ">' + memberList[i].publicTime + '</div>' +
                '</div>' +
                "</a>"
            $(".content-list-box").html(contentList)
        }
    })
})

// 加载更多
$(document).ready(function () {
    let num = 12
    $(".more").click(function () {
        num += 12
        $.get(`/api/admin/official/exc/informationPageList/${id}?current=1&size=` + num, function (data) {
            const memberList = data.data.records
            var contentList = ''
            $.each(memberList, function (i, item) {
                if (memberList[i].subtitle === null) {
                    memberList[i].subtitle = ""
                }
                if (memberList[i].coverUrl === "") {
                    memberList[i].coverUrl = "/static/images/bg.png"
                }
                if (memberList[i].linkType === 0 || memberList[i].linkType === null) {
                    contentList +=
                        "<a class= " + 'content-list ' + "href=" + 'memberDetail.html?idx=4&id=' + memberList[i].id + '&nav=' + encodeURI(nav) + ">" +
                        "<img class= " + 'content-img ' + "src=" + memberList[i].coverUrl + ">" + "</img>" +
                        '<div class="detail-title">' + memberList[i].title + '</div>' +
                        '<div class="content-detail">' +
                        '<div class="detail-content">' + memberList[i].subtitle + '</div>' +
                        '<div class="detail-time ">' + memberList[i].publicTime + '</div>' +
                        '</div>' +
                        "</a>"
                    $(".content-list-box").html(contentList)
                } else {
                    contentList +=
                        "<a class= " + 'content-list ' + "href=" + memberList[i].linkUrl + ' target=_blank' + ">" +
                        "<img class= " + 'content-img ' + "src=" + memberList[i].coverUrl + ">" + "</img>" +
                        '<div class="detail-title">' + memberList[i].title + '</div>' +
                        '<div class="content-detail">' +
                        '<div class="detail-content">' + memberList[i].subtitle + '</div>' +
                        '<div class="detail-time ">' + memberList[i].publicTime + '</div>' +
                        '</div>' +
                        "</a>"
                    $(".content-list-box").html(contentList)
                }
            })
            if (data.data.size >= data.data.total) {
                $(".more").hide()
            }
        })
    })
})
